<template>
  <v-container>
    <v-app-bar color="red darken-2" dark fixed>

      <SearchForm v-on:search="doSearch" v-on="$listeners" v-bind:searchString="what" v-bind:inSearch="true" class="title_input"/>


      <v-spacer/>


        <v-btn icon v-if="!this.history">
          <v-badge
              color="green"
              :content="historySize"
              :value="historySize"
          >

            <v-icon
                @click="displayHistory">mdi-history
            </v-icon>
          </v-badge>
        </v-btn>
        <v-btn icon v-if="this.history">
          <v-icon
              @click="displayResult">mdi-text-search
          </v-icon>
        </v-btn>


    </v-app-bar>


    <v-row>&nbsp; -</v-row>
    <v-row>&nbsp; -</v-row>
    <v-row>
      <SearchResults
          v-if="siretDatas && siretDatas.length > 0 && !this.searching()"
          v-bind:sirets="siretDatas"
          v-bind:reformattedSearchString="what"
      />
    </v-row>
    <v-row style="justify-content: center;" v-if="this.searching()">
      <div class="text-center progresseur"  width="100%">
        <v-progress-circular
            indeterminate
            color="primary"
        ></v-progress-circular>
      </div>
    </v-row>

  </v-container>
</template>

<script>
import SearchForm from '@/components/layout/SearchForm';
import SearchResults from '@/components/freeSearch/SearchResults';

export default {
  name: "Siret",
  components: {
    SearchForm,
    SearchResults,
  },
  props: {
    search: String
  },
  data() {
    return {
      what: "",
      oldwhat: "",
      history: false
    }
  },
  computed: {
    historySize() {
      var size = this.$store.state.historiqueConsultes.length
      return (size > 0 ? size : "")
    },
    siretDatas() {
      return this.$store.state.searchResult
    },
  },
  beforeUpdate() {
    // called when field what is changed
    if (this.what != this.oldwhat) {
      this.oldwhat = this.what
      this.searchSiret(this.what, this.active)
    }
  },
  beforeMount() {

    this.what = (this.search === undefined ? "" : this.search)
    this.oldwhat = this.what
  },
  mounted() {

  },
  methods: {
    displayHistory() {
      this.$store.dispatch('getHistory')
      this.history = true
    },
    displayResult() {
      this.$store.dispatch('getResults')
      this.history = false
    },
    searchSiret(what, active) {
      // get data from store
      this.$store.dispatch('findSiretFor', { what, active})

    },
    doSearch(searchParams, active) {
      if (searchParams != null) {
        this.what = searchParams.join(' ');
      } else {
        this.what =""
      }
      this.searchSiret(this.what, active)
    },
    searching() {
      return this.$store.state.searchingSiret
    }
  }
}
</script>

<style scoped>

.v-progress-circular {
  margin: 1rem;
}


</style>